import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import BalanceApi from '../../services/api/BalanceApi';
import { RootState } from '../../types';

const setBalanceLoading = createAction<{ type: 'info'; value: boolean }>(
  'balance/setLoading'
);

const fetchBalanceInfo = createAsyncThunk(
  'balance/fetchBalanceInfo',
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setBalanceLoading({ type: 'info', value: true }));
      const store = thunkAPI.getState() as RootState;
      const response = store.auth.account.id
        ? await BalanceApi.getBalanceInfo(store.auth.account.id)
        : null;
      if (response?.status === 200) {
        return response?.data;
      }
      return undefined;
    } finally {
      thunkAPI.dispatch(setBalanceLoading({ type: 'info', value: false }));
    }
  }
);

export { fetchBalanceInfo, setBalanceLoading };
